import React, { useState, useRef, useEffect } from 'react';
import {
  Share2,
  Link as LinkIcon,
  Lock,
  Unlock,
  X,
  Copy,
  Check
} from 'lucide-react';

/**
 * ComparisonCardActions - Share & Open Link
 * FIXED: Centered icons in mobile popup
 */

// Social media icons as SVG components
const SocialIcons = {
  WhatsApp: () => (
    <svg viewBox="0 0 24 24" className="w-5 h-5" fill="#25D366">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
    </svg>
  ),
  Facebook: () => (
    <svg viewBox="0 0 24 24" className="w-5 h-5" fill="#1877F2">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
    </svg>
  ),
  Twitter: () => (
    <svg viewBox="0 0 24 24" className="w-5 h-5" fill="#000000">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
    </svg>
  ),
  LinkedIn: () => (
    <svg viewBox="0 0 24 24" className="w-5 h-5" fill="#0A66C2">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
    </svg>
  ),
  Telegram: () => (
    <svg viewBox="0 0 24 24" className="w-5 h-5" fill="#0088cc">
      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
    </svg>
  )
};

function ComparisonCardActions({ comparison, onTogglePrivacy, isOwner }) {
  const [showShareMenu, setShowShareMenu] = useState(false);
  const [copied, setCopied] = useState(false);
  const shareMenuRef = useRef(null);

  // Close menu on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (shareMenuRef.current && !shareMenuRef.current.contains(event.target)) {
        setShowShareMenu(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // NULL CHECK - Return null if no comparison
  if (!comparison || !comparison.run_id) {
    return null;
  }

  const shareUrl = `${window.location.origin}/result/${comparison.run_id}`;
  const shareText = `Check out this AI model comparison on MidoLABS! 🤖\n${comparison.category?.replace(/_/g, ' ') || ''}`;

  // ==========================================
  // SHARE HANDLERS
  // ==========================================

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'MidoLABS Comparison',
          text: shareText,
          url: shareUrl
        });
        return;
      } catch (err) {
        // User cancelled or not supported
      }
    }
    setShowShareMenu(true);
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
        setShowShareMenu(false);
      }, 1500);
    } catch (error) {
      console.error('Failed to copy:', error);
    }
  };

  const shareToWhatsApp = () => {
    window.open(`https://wa.me/?text=${encodeURIComponent(shareText + '\n' + shareUrl)}`, '_blank');
    setShowShareMenu(false);
  };

  const shareToFacebook = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`, '_blank', 'width=600,height=400');
    setShowShareMenu(false);
  };

  const shareToTwitter = () => {
    window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`, '_blank', 'width=600,height=400');
    setShowShareMenu(false);
  };

  const shareToLinkedIn = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`, '_blank', 'width=600,height=400');
    setShowShareMenu(false);
  };

  const shareToTelegram = () => {
    window.open(`https://t.me/share/url?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText)}`, '_blank');
    setShowShareMenu(false);
  };

  const handleOpenLink = () => {
    window.open(`/result/${comparison.run_id}`, '_blank');
  };

  // ==========================================
  // RENDER
  // ==========================================

  return (
    <div className="flex items-center justify-center space-x-1 relative" data-actions="true">
      {/* Share button */}
      <div className="relative" ref={shareMenuRef}>
        <button
          onClick={handleShare}
          className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          title="Share"
        >
          <Share2 size={16} className="text-gray-600" />
        </button>

        {/* Share Menu */}
        {showShareMenu && (
          <div className="absolute right-0 top-full mt-2 w-56 bg-white rounded-xl shadow-xl border border-gray-200 overflow-hidden z-50">
            <div className="px-4 py-3 border-b border-gray-100 flex items-center justify-between">
              <span className="font-semibold text-gray-800">Share to</span>
              <button onClick={() => setShowShareMenu(false)} className="p-1 hover:bg-gray-100 rounded">
                <X size={14} className="text-gray-500" />
              </button>
            </div>

            <div className="p-2">
              <button onClick={shareToWhatsApp} className="w-full flex items-center space-x-3 px-3 py-2.5 hover:bg-gray-50 rounded-lg">
                <SocialIcons.WhatsApp />
                <span className="text-sm font-medium text-gray-700">WhatsApp</span>
              </button>
              <button onClick={shareToFacebook} className="w-full flex items-center space-x-3 px-3 py-2.5 hover:bg-gray-50 rounded-lg">
                <SocialIcons.Facebook />
                <span className="text-sm font-medium text-gray-700">Facebook</span>
              </button>
              <button onClick={shareToTwitter} className="w-full flex items-center space-x-3 px-3 py-2.5 hover:bg-gray-50 rounded-lg">
                <SocialIcons.Twitter />
                <span className="text-sm font-medium text-gray-700">X (Twitter)</span>
              </button>
              <button onClick={shareToLinkedIn} className="w-full flex items-center space-x-3 px-3 py-2.5 hover:bg-gray-50 rounded-lg">
                <SocialIcons.LinkedIn />
                <span className="text-sm font-medium text-gray-700">LinkedIn</span>
              </button>
              <button onClick={shareToTelegram} className="w-full flex items-center space-x-3 px-3 py-2.5 hover:bg-gray-50 rounded-lg">
                <SocialIcons.Telegram />
                <span className="text-sm font-medium text-gray-700">Telegram</span>
              </button>
            </div>

            <div className="p-2 border-t border-gray-100">
              <button
                onClick={handleCopyLink}
                className={`w-full flex items-center justify-center space-x-2 px-3 py-2.5 rounded-lg ${
                  copied ? 'bg-green-50 text-green-600' : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
                }`}
              >
                {copied ? <><Check size={16} /><span className="text-sm font-medium">Copied!</span></>
                        : <><Copy size={16} /><span className="text-sm font-medium">Copy Link</span></>}
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Open link */}
      <button onClick={handleOpenLink} className="p-2 hover:bg-gray-100 rounded-lg" title="Open">
        <LinkIcon size={16} className="text-gray-600" />
      </button>

      {/* Privacy toggle */}
      {isOwner && onTogglePrivacy && (
        <button
          onClick={onTogglePrivacy}
          className="p-2 hover:bg-gray-100 rounded-lg"
          title={comparison.is_public ? 'Make Private' : 'Make Public'}
        >
          {comparison.is_public ? <Unlock size={16} className="text-green-600" /> : <Lock size={16} className="text-gray-600" />}
        </button>
      )}
    </div>
  );
}

export default ComparisonCardActions;